/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_EXCLUDED_CLAIMS,
  payload: value,
});
export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_EXCLUDED_CLAIMS,
  payload: data,
});

export const setNonInvoiceData = (data) => ({
  type: ActionTypes.SET_ALL_NON_INVOICE_DATA,
  payload: data,
});
export const setRebateProgramData = (data) => ({
  type: ActionTypes.SET_REBATE_PROGRAM_DATA,
  payload: data,
});

export const refreshExcludedClaims = () => ({
  type: ActionTypes.REFRESH_EXCLUDED_CLAIMS,
  payload: {},
});
// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_EXCLUDED_CLAIMS,
  isLoading: value,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch(() => {
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data.data;
    })
    .catch((response) => {});
};

// Drop Down
export const getNonInvoiceReasonCode = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_EXCLUDED_CLAIMS_DROP_DOWN}`, values)
    .then((response) => {
      return dispatch({
        type: ActionTypes.EXCLUDED_CLAIMS_DROP_DOWN,
        excludedClaimsDropDown: response.data,
      });
    })
    .catch((response) => {
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setExcludedClaimsGrid = (data) => ({
  type: ActionTypes.EXCLUDED_CLAIMS_RESULT_GRID,
  searchResult: data,
});

// action set Network error
export const setNetworkError = (data) => ({
  type: ActionTypes.SET_NEWORK_ERROR,
  payload: data,
});

// Result Grid
export const getResultGridExcludedClaims = (values) => (dispatch) => {
  dispatch(setPdfInvoice(''));
  return axios
    .post(`${serviceEndPoint.GET_EXCLUDED_CLAIMS_RESULT_GRID}`, values)
    .then((response) => {
      if (response.data?.excludedClaimsReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setExcludedClaimsGrid(response.data?.excludedClaimsReportVO)
        );
      }
    })
    .catch((error) => {
      if (
        error.message === 'Network Error' ||
        error.message === 'Request failed with status code 502'
      ) {
        dispatch(setNetworkError(true));
      }
      dispatch(setExcludedClaimsGrid([]));
    });
};
export const setPdfInvoice = (data) => {
  return {
    type: ActionTypes.GENERATE_PDF_DATA,
    pdfPrev: data,
  };
};
export const getExcludedClaimsGeneratePDF = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EXCLUDE_CLAIMS_PDF, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return dispatch(setPdfInvoice(response.data));
    })
    .catch(() => {
      dispatch(setPdfInvoice('failed'));
    });
};
export const clearReduxExcludedClaimsSearchScreen = () => (dispatch) => {
  dispatch(dispatchPlanType([]));
  dispatch({
    type: ActionTypes.EXCLUDED_CLAIMS_DROP_DOWN,
    excludedClaimsDropDown: [],
  });
  dispatch(setLoading(false));
  dispatch(setNetworkError(false));
  dispatch(setSearchInput({ errors: [] }));
};
export const clearReduxExcludedClaimsDetailsScreen = () => (dispatch) => {
  dispatch(setExcludedClaimsGrid([]));
  dispatch(setPdfInvoice(''));
  //dispatch(refreshExcludedClaims({}));
};
